module.exports = __webpack_public_path__ + "static/img/logo-filled.f05dda2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-filled.png
// module id = x1x3
// module chunks = 1